import React from "react"

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.linkedin.com/in/wakil18" className="home__social-icon" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
                <i className="uil uil-linkedin-alt" aria-hidden="true"></i>
            </a>

            <a href="https://m.me/wakil.ahmed.581" className="home__social-icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook Messenger">
                <i className="uil uil-facebook-messenger-alt" aria-hidden="true"></i>
            </a>

            <a href="https://github.com/Wakil18" className="home__social-icon" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile">
                <i className="uil uil-github-alt" aria-hidden="true"></i>
            </a>
        </div>
    )
}

export default Social
